export const formatTime = (
  params:
    | string
    | Date
    | number
    | { value?: string | Date | number }
    | null
    | undefined = 'timeSpan',
  format: string
) => {
  // MUI DataGrid v8 passes the raw cell value; older callers pass { value }.
  const value =
    params instanceof Date ||
    typeof params === 'string' ||
    typeof params === 'number'
      ? params
      : params?.value;

  if (value === null || value === undefined || value === '') {
    return 'Nincs';
  }

  const localTime = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(localTime.getTime())) {
    return 'Nincs';
  }

  if (format === 'hours') {
    return localTime.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  }

  const formattedTime = localTime.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const formattedDate = localTime.toLocaleDateString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  return `${formattedDate}.${formattedTime}`;
};
